<template>
  <md-button class="md-info btn_nanosoft">
    <download-excel
      name="الكشف التحليلى لشهر"
      :stringifyLongNum="true"
      :fetch="fetchData"
    >
      طباعة Excel
    </download-excel>
  </md-button>
</template>

<script>
import axios from "axios";
import env from "../../../env";
export default {
  props: ["month"],
  data() {
    return {
      json_fields: {},
    };
  },
  methods: {
    async fetchData() {
      if (this.month == "1970-1-1") {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "عفواً، الرجاء ادخال شهر المرتب "
        );
      }
      let T = localStorage.getItem("Nannotoken");
      let token = atob(T);
      let res = await axios.get(
        `${env.HR()}/api/SalariesReports/GeneralAnalytical?MonthDate=${
          this.month
        }`,
        {
          headers: { Authorization: "Bearer " + token },
        }
      );

      return [res.data.data];
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>